import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  title: string;
  indexHref: string;
};

/**
 * 社内報編集ヘッダーの Presentation コンポーネント
 * パンくずリスト付きページヘッダーを表示する
 */
export const EditInternalNewsHeaderPresentation: React.FC<Props> = ({ title, indexHref }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '社内報', href: indexHref }, { label: `${title}の編集` }]}
  />
);
